(function(){
/* Zumm Health — shared components (React + Framer Motion UMD) */
const {
  motion,
  AnimatePresence,
  useScroll,
  useTransform,
  useMotionValueEvent,
  useSpring,
  useInView
} = window.Motion;
const {
  useState,
  useEffect,
  useRef,
  useMemo
} = React;

/* ---------------- data ---------------- */
const SOCIALS = [{
  id: 'instagram',
  label: 'Instagram',
  href: 'https://www.instagram.com/zummhealth'
}, {
  id: 'tiktok',
  label: 'TikTok',
  href: 'https://www.tiktok.com/@zummhealth'
}, {
  id: 'facebook',
  label: 'Facebook',
  href: 'https://www.facebook.com/zummhealth'
}, {
  id: 'youtube',
  label: 'YouTube',
  href: 'https://www.youtube.com/@zummhealth'
}, {
  id: 'amazon',
  label: 'Amazon Store',
  href: 'https://www.amazon.com/s?k=zumm+health'
}];
const PRODUCTS = {
  'probiotic-60': {
    id: 'probiotic-60',
    page: 'probiotic-60.html',
    name: 'Buds BLS‑3 Pro Max',
    line: "Doctor's Choice Probiotic — 60 Billion CFU",
    short: '10 strains + organic prebiotics + 9 digestive enzymes. Max‑strength support in one daily capsule, for adults and kids 4+.',
    price: 49.99,
    img: window.ZUMM_IMG["probiotic-60-front.webp"],
    accent: '#5E8BC4',
    glow: 'rgba(94,139,196,.45)',
    btn: 'btn-orange',
    tag: 'Max Strength · 1‑a‑Day'
  },
  'probiotic-24': {
    id: 'probiotic-24',
    page: 'probiotic-24.html',
    name: 'Buds Pro Jr.',
    line: "Doctor's Choice Kids Probiotic — 24 Billion CFU",
    short: '7 kid‑friendly strains + prebiotic FOS + 4 digestive enzymes in an acid‑resistant DRcaps® capsule. Sugar‑free.',
    price: 39.99,
    img: window.ZUMM_IMG["probiotic-24-front.webp"],
    accent: '#3FD598',
    glow: 'rgba(45,155,111,.45)',
    btn: 'btn-green',
    tag: 'Kids · Pediatrician‑Formulated'
  },
  'multivitamin': {
    id: 'multivitamin',
    page: 'multivitamin.html',
    name: 'Daily Kids Multivitamin',
    line: 'With Minerals, Iron + Ayurvedic Blend — Ages 4+',
    short: '19 vitamins & minerals plus amla and triphala in a mixed‑berry chewable. Sweetened with monk fruit — sugar‑free.',
    price: 39.99,
    img: window.ZUMM_IMG["multivitamin-front.webp"],
    accent: '#FF8C42',
    glow: 'rgba(255,140,66,.42)',
    btn: 'btn-orange',
    tag: 'Chewable · Mixed Berry'
  },
  'book': {
    id: 'book',
    page: 'wrong-gummy-book.html',
    name: 'Wrong Gummy — Kids Edition',
    line: "…Chew On This!!! The doctor's honest dose on supplements",
    short: "Supplements explained in kids' language — why most gummies are candy in disguise, and what to look for instead.",
    price: 9.99,
    img: window.ZUMM_IMG["wrong-gummy-cover.webp"],
    accent: '#F4E04D',
    glow: 'rgba(244,224,77,.35)',
    btn: 'btn-yellow',
    tag: 'The Book Parents Ask For'
  }
};
const ORBIT_ORDER = ['probiotic-60', 'probiotic-24', 'multivitamin', 'book'];

/* ---------------- icons ---------------- */
const ICON_PATHS = {
  instagram: 'M12 2.2c3.2 0 3.6 0 4.9.1 1.2.1 1.8.2 2.2.4.6.2 1 .5 1.4.9.4.4.7.8.9 1.4.2.4.4 1 .4 2.2.1 1.3.1 1.7.1 4.9s0 3.6-.1 4.9c-.1 1.2-.2 1.8-.4 2.2-.2.6-.5 1-.9 1.4-.4.4-.8.7-1.4.9-.4.2-1 .4-2.2.4-1.3.1-1.7.1-4.9.1s-3.6 0-4.9-.1c-1.2-.1-1.8-.2-2.2-.4-.6-.2-1-.5-1.4-.9-.4-.4-.7-.8-.9-1.4-.2-.4-.4-1-.4-2.2C2.2 15.6 2.2 15.2 2.2 12s0-3.6.1-4.9c.1-1.2.2-1.8.4-2.2.2-.6.5-1 .9-1.4.4-.4.8-.7 1.4-.9.4-.2 1-.4 2.2-.4C8.4 2.2 8.8 2.2 12 2.2zm0 1.8c-3.1 0-3.5 0-4.8.1-1.1.1-1.5.2-1.9.3-.5.2-.8.4-1.1.7-.3.3-.5.6-.7 1.1-.1.4-.3.8-.3 1.9-.1 1.3-.1 1.6-.1 4.8s0 3.5.1 4.8c.1 1.1.2 1.5.3 1.9.2.5.4.8.7 1.1.3.3.6.5 1.1.7.4.1.8.3 1.9.3 1.3.1 1.6.1 4.8.1s3.5 0 4.8-.1c1.1-.1 1.5-.2 1.9-.3.5-.2.8-.4 1.1-.7.3-.3.5-.6.7-1.1.1-.4.3-.8.3-1.9.1-1.3.1-1.6.1-4.8s0-3.5-.1-4.8c-.1-1.1-.2-1.5-.3-1.9-.2-.5-.4-.8-.7-1.1-.3-.3-.6-.5-1.1-.7-.4-.1-.8-.3-1.9-.3-1.3-.1-1.6-.1-4.8-.1zm0 3.1a4.9 4.9 0 110 9.8 4.9 4.9 0 010-9.8zm0 8.1a3.2 3.2 0 100-6.4 3.2 3.2 0 000 6.4zm6.2-8.3a1.1 1.1 0 11-2.3 0 1.1 1.1 0 012.3 0z',
  tiktok: 'M16.6 3c.4 2 1.7 3.4 3.7 3.6v3c-1.5 0-2.8-.5-3.8-1.2v5.6c0 3.5-2.4 5.9-5.6 5.9A5.5 5.5 0 015.3 14c0-3.2 2.4-5.6 5.7-5.6.3 0 .7 0 1 .1v3.1c-.3-.1-.7-.2-1-.2-1.6 0-2.8 1.2-2.8 2.7 0 1.6 1.2 2.7 2.7 2.7 1.6 0 2.8-1.1 2.8-2.9V3h2.9z',
  facebook: 'M13.5 21v-7.5h2.5l.4-3h-2.9V8.6c0-.9.3-1.5 1.6-1.5h1.4V4.4c-.3 0-1.1-.1-2.1-.1-2.1 0-3.6 1.3-3.6 3.7v2.5H8.3v3h2.5V21h2.7z',
  youtube: 'M21.6 7.2c-.2-.9-.9-1.6-1.8-1.8C18.2 5 12 5 12 5s-6.2 0-7.8.4c-.9.2-1.6.9-1.8 1.8C2 8.8 2 12 2 12s0 3.2.4 4.8c.2.9.9 1.6 1.8 1.8C5.8 19 12 19 12 19s6.2 0 7.8-.4c.9-.2 1.6-.9 1.8-1.8.4-1.6.4-4.8.4-4.8s0-3.2-.4-4.8zM10 15V9l5.2 3L10 15z',
  amazon: 'M14.2 12.9c0 .8 0 1.5-.4 2.2-.3.6-.9 1-1.5 1-.8 0-1.3-.6-1.3-1.6 0-1.8 1.7-2.2 3.2-2.2v.6zm2.2 5.2c-.1.1-.3.1-.5.1-.6-.5-.8-.8-1.1-1.3-1 1-1.8 1.4-3.1 1.4-1.6 0-2.9-1-2.9-3 0-1.5.8-2.6 2-3.1 1-.4 2.5-.5 3.6-.7v-.2c0-.4 0-1-.2-1.3-.3-.4-.7-.5-1.1-.5-.8 0-1.5.4-1.6 1.2 0 .2-.2.4-.4.4l-1.9-.2c-.2 0-.4-.2-.3-.4.4-2.3 2.5-3 4.4-3 1 0 2.2.3 3 1 1 .9.9 2.1.9 3.5v3.1c0 .9.4 1.4.8 1.9.1.2.2.4 0 .5l-1.6 1.4v-.1zM19.8 18c-2.1 1.6-5.2 2.4-7.9 2.4-3.7 0-7.1-1.4-9.6-3.7-.2-.2 0-.4.2-.3 2.7 1.6 6.1 2.5 9.6 2.5 2.3 0 4.9-.5 7.3-1.5.4-.1.7.3.4.6zm.9-1c-.3-.3-1.8-.2-2.5-.1-.2 0-.2-.1-.1-.3.6-.9 1.7-.6 1.9-.4.2.2-.1 2.2-.9 3.2-.1.2-.3.1-.2-.1.2-.7.6-2 .3-2.3h1.5z'
};
function SocialIcon({
  id
}) {
  return /*#__PURE__*/React.createElement("svg", {
    viewBox: "0 0 24 24",
    "aria-hidden": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: ICON_PATHS[id]
  }));
}

/* ---------------- toast ---------------- */
function useToast() {
  const [msg, setMsg] = useState(null);
  const show = m => {
    setMsg(m);
    clearTimeout(show.t);
    show.t = setTimeout(() => setMsg(null), 3200);
  };
  const node = /*#__PURE__*/React.createElement(AnimatePresence, null, msg && /*#__PURE__*/React.createElement(motion.div, {
    className: "toast",
    key: "toast",
    initial: {
      opacity: 0,
      y: 24,
      x: '-50%'
    },
    animate: {
      opacity: 1,
      y: 0,
      x: '-50%'
    },
    exit: {
      opacity: 0,
      y: 12,
      x: '-50%'
    },
    transition: {
      type: 'spring',
      stiffness: 400,
      damping: 28
    }
  }, msg));
  return [node, show];
}
function buyClick(showToast, product) {
  return e => {
    e.preventDefault();
    showToast(`🛒 ${product.name} — $${product.price.toFixed(2)}. Checkout opens here once the store connects to Shopify.`);
  };
}

/* ---------------- nav ---------------- */
const NAV_LINKS = [{
  href: 'index.html',
  label: 'Home'
}, {
  href: 'probiotic-60.html',
  label: '60 Billion'
}, {
  href: 'probiotic-24.html',
  label: 'Kids 24 Billion'
}, {
  href: 'multivitamin.html',
  label: 'Multivitamin'
}, {
  href: 'wrong-gummy-book.html',
  label: 'The Book'
}, {
  href: 'science.html',
  label: 'Science'
}, {
  href: 'blog.html',
  label: 'Blog'
}, {
  href: 'about.html',
  label: 'About'
}];
function Nav({
  current
}) {
  const [open, setOpen] = useState(false);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(motion.nav, {
    className: "nav",
    initial: {
      y: -70,
      opacity: 0
    },
    animate: {
      y: 0,
      opacity: 1
    },
    transition: {
      duration: .55,
      ease: 'easeOut'
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "nav-inner"
  }, /*#__PURE__*/React.createElement("a", {
    className: "nav-logo",
    href: "index.html",
    "aria-label": "Zumm Health home"
  }, /*#__PURE__*/React.createElement("img", {
    src: window.ZUMM_IMG["zumm-logo.webp"],
    alt: "Zumm Health — Be Your Best"
  })), /*#__PURE__*/React.createElement("div", {
    className: "nav-links"
  }, NAV_LINKS.map(l => /*#__PURE__*/React.createElement(motion.a, {
    key: l.href,
    href: l.href,
    className: 'nav-link' + (current === l.href ? ' active' : ''),
    whileHover: {
      y: -2
    },
    whileTap: {
      scale: .96
    }
  }, l.label)), /*#__PURE__*/React.createElement(motion.a, {
    href: "index.html#shop",
    className: "nav-cta",
    whileHover: {
      scale: 1.06
    },
    whileTap: {
      scale: .95
    }
  }, "Shop Now")), /*#__PURE__*/React.createElement("button", {
    className: "nav-burger",
    "aria-label": "Menu",
    onClick: () => setOpen(v => !v)
  }, /*#__PURE__*/React.createElement("span", null), /*#__PURE__*/React.createElement("span", null), /*#__PURE__*/React.createElement("span", null)))), /*#__PURE__*/React.createElement(AnimatePresence, null, open && /*#__PURE__*/React.createElement(motion.div, {
    className: "mobile-menu",
    key: "mm",
    initial: {
      opacity: 0
    },
    animate: {
      opacity: 1
    },
    exit: {
      opacity: 0
    },
    onClick: () => setOpen(false)
  }, NAV_LINKS.map((l, i) => /*#__PURE__*/React.createElement(motion.a, {
    key: l.href,
    href: l.href,
    className: 'nav-link' + (current === l.href ? ' active' : ''),
    initial: {
      opacity: 0,
      y: 18
    },
    animate: {
      opacity: 1,
      y: 0
    },
    transition: {
      delay: .05 * i
    }
  }, l.label)))), /*#__PURE__*/React.createElement(ThemeSwitch, null));
}

/* ---------------- theme switcher ---------------- */
const THEMES = [{
  id: 'dark',
  label: 'Dark',
  cls: ''
}, {
  id: 'slate',
  label: 'Lighter',
  cls: 'theme-slate'
}, {
  id: 'light',
  label: 'Light',
  cls: 'theme-light'
}];
function applyTheme(id) {
  const t = THEMES.find(x => x.id === id) || THEMES[0];
  document.documentElement.classList.remove('theme-slate', 'theme-light');
  if (t.cls) document.documentElement.classList.add(t.cls);
  try {
    localStorage.setItem('zumm-theme', id);
  } catch (e) {}
}
function ThemeSwitch() {
  const [theme, setTheme] = useState('dark');
  useEffect(() => {
    let saved = 'dark';
    try {
      saved = localStorage.getItem('zumm-theme') || 'dark';
    } catch (e) {}
    setTheme(saved);
    applyTheme(saved);
  }, []);
  const pick = id => {
    setTheme(id);
    applyTheme(id);
  };
  return /*#__PURE__*/React.createElement(motion.div, {
    className: "theme-switch",
    role: "group",
    "aria-label": "Background theme",
    initial: {
      opacity: 0,
      y: 20
    },
    animate: {
      opacity: 1,
      y: 0
    },
    transition: {
      delay: .6
    }
  }, THEMES.map(t => /*#__PURE__*/React.createElement("button", {
    key: t.id,
    className: theme === t.id ? 'on' : '',
    onClick: () => pick(t.id),
    "aria-pressed": theme === t.id
  }, t.label)));
}

/* ---------------- scroll progress bar ---------------- */
function TopBar() {
  const {
    scrollYProgress
  } = useScroll();
  const scaleX = useSpring(scrollYProgress, {
    stiffness: 140,
    damping: 26,
    mass: .4
  });
  return /*#__PURE__*/React.createElement(motion.div, {
    className: "scrollbar-top",
    style: {
      scaleX
    }
  });
}

/* ---------------- floating microbes ---------------- */
function Microbes({
  count = 14,
  colors = ['#2D9B6F', '#5E8BC4', '#FF8C42', '#F4E04D']
}) {
  const items = useMemo(() => Array.from({
    length: count
  }, (_, i) => ({
    id: i,
    size: 6 + i * 37 % 26,
    left: i * 53 % 100,
    top: i * 31 % 100,
    color: colors[i % colors.length],
    dur: 7 + i * 13 % 9,
    delay: i * 7 % 5
  })), [count]);
  return /*#__PURE__*/React.createElement("div", {
    className: "microbes",
    "aria-hidden": "true"
  }, items.map(m => /*#__PURE__*/React.createElement(motion.span, {
    key: m.id,
    className: "microbe",
    style: {
      width: m.size,
      height: m.size,
      left: m.left + '%',
      top: m.top + '%',
      background: m.color,
      boxShadow: `0 0 ${m.size * 1.6}px ${m.color}`
    },
    animate: {
      y: [0, -34, 8, 0],
      x: [0, 14, -10, 0],
      opacity: [.25, .6, .35, .25]
    },
    transition: {
      duration: m.dur,
      delay: m.delay,
      repeat: Infinity,
      ease: 'easeInOut'
    }
  })));
}

/* ---------------- marquee ---------------- */
function Marquee({
  items
}) {
  const row = /*#__PURE__*/React.createElement("div", {
    className: "marquee-item"
  }, items.map((t, i) => /*#__PURE__*/React.createElement(React.Fragment, {
    key: i
  }, /*#__PURE__*/React.createElement("span", null, t), /*#__PURE__*/React.createElement("span", {
    className: "dot"
  }))));
  return /*#__PURE__*/React.createElement("div", {
    className: "marquee",
    "aria-hidden": "true"
  }, /*#__PURE__*/React.createElement(motion.div, {
    className: "marquee-track",
    animate: {
      x: ['0%', '-50%']
    },
    transition: {
      duration: 26,
      repeat: Infinity,
      ease: 'linear'
    }
  }, row, row));
}

/* ---------------- reveal helpers ---------------- */
const fadeUp = {
  hidden: {
    opacity: 0,
    y: 34
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: .65,
      ease: [0.21, 0.65, 0.36, 1]
    }
  }
};
const stagger = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: .12
    }
  }
};
function Reveal({
  children,
  as = 'div',
  className,
  variants = fadeUp,
  amount = .35,
  ...rest
}) {
  const Tag = motion[as];
  return /*#__PURE__*/React.createElement(Tag, {
    className: className,
    variants: variants,
    initial: "hidden",
    whileInView: "visible",
    viewport: {
      once: true,
      amount
    },
    ...rest
  }, children);
}

/* ---------------- footer ---------------- */
function Footer() {
  return /*#__PURE__*/React.createElement("footer", {
    className: "footer"
  }, /*#__PURE__*/React.createElement("div", {
    className: "wrap"
  }, /*#__PURE__*/React.createElement("div", {
    className: "footer-grid"
  }, /*#__PURE__*/React.createElement("div", {
    className: "brand"
  }, /*#__PURE__*/React.createElement("a", {
    className: "logo",
    href: "index.html"
  }, /*#__PURE__*/React.createElement("img", {
    src: window.ZUMM_IMG["zumm-logo.webp"],
    alt: "Zumm Health"
  })), /*#__PURE__*/React.createElement("p", null, "No gummies. No sugar. No nonsense. Pediatrician‑formulated supplements that make it past the taste buds and into the gut."), /*#__PURE__*/React.createElement("div", {
    className: "socials"
  }, SOCIALS.map(s => /*#__PURE__*/React.createElement(motion.a, {
    key: s.id,
    className: "social",
    href: s.href,
    target: "_blank",
    rel: "noopener",
    "aria-label": s.label,
    whileHover: {
      y: -5,
      scale: 1.1,
      color: '#F4E04D'
    },
    whileTap: {
      scale: .92
    }
  }, /*#__PURE__*/React.createElement(SocialIcon, {
    id: s.id
  }))))), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h4", null, "Shop"), /*#__PURE__*/React.createElement("a", {
    className: "f-link",
    href: "probiotic-60.html"
  }, "Probiotic 60 Billion CFU"), /*#__PURE__*/React.createElement("a", {
    className: "f-link",
    href: "probiotic-24.html"
  }, "Kids Probiotic 24 Billion"), /*#__PURE__*/React.createElement("a", {
    className: "f-link",
    href: "multivitamin.html"
  }, "Kids Multivitamin"), /*#__PURE__*/React.createElement("a", {
    className: "f-link",
    href: "wrong-gummy-book.html"
  }, "Wrong Gummy — the Book")), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h4", null, "Learn"), /*#__PURE__*/React.createElement("a", {
    className: "f-link",
    href: "science.html"
  }, "The Science"), /*#__PURE__*/React.createElement("a", {
    className: "f-link",
    href: "blog.html"
  }, "Blog · The Journal"), /*#__PURE__*/React.createElement("a", {
    className: "f-link",
    href: "about.html"
  }, "About Zumm Health"), /*#__PURE__*/React.createElement("a", {
    className: "f-link",
    href: "index.html#why"
  }, "Why No Gummies?")), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h4", null, "Get in touch"), /*#__PURE__*/React.createElement("a", {
    className: "f-link",
    href: "mailto:hello@zummhealth.com"
  }, "hello@zummhealth.com"), /*#__PURE__*/React.createElement("p", {
    style: {
      color: 'var(--text-dim)',
      fontSize: 14,
      marginTop: 10
    }
  }, "Zumm Health LLC", /*#__PURE__*/React.createElement("br", null), "522 W Riverside Ave Ste N", /*#__PURE__*/React.createElement("br", null), "Spokane, WA 99201"))), /*#__PURE__*/React.createElement("p", {
    className: "fda"
  }, "*These statements have not been evaluated by the Food and Drug Administration. These products are not intended to diagnose, treat, cure, or prevent any disease. Always consult your child's healthcare professional before starting any supplement."), /*#__PURE__*/React.createElement("div", {
    className: "copyright"
  }, /*#__PURE__*/React.createElement("span", null, "© ", new Date().getFullYear(), " Zumm Health LLC. All rights reserved."), /*#__PURE__*/React.createElement("span", null, "Be Your Best."))));
}
window.Z = {
  PRODUCTS,
  ORBIT_ORDER,
  SOCIALS,
  Nav,
  Footer,
  TopBar,
  Microbes,
  Marquee,
  Reveal,
  fadeUp,
  stagger,
  useToast,
  buyClick,
  SocialIcon
};})();
